export const SEARCH_ENDPOINTS = {
  DILEMMAS: "/dilemmas/?status=published",
};
